import React from 'react'
import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css";

const ProductGallery = ({ product }) => {
    const imageArray = product.image?.split(',') || [];
  return (
    <Carousel
      showThumbs={false}
      infiniteLoop
      showStatus={false}
      useKeyboardArrows
      autoPlay={false}
      showIndicators={false}
    >
      {imageArray.map((img, index) => (
        <div key={index}>
          <img src={`/uploads/${img.trim()}`} alt={`Product image ${index + 1}`} />
        </div>
      ))}
    </Carousel>
  )
}

export default ProductGallery